import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const productCustomsFieldSchema = z.enum([
  "hsCode",
  "originCountry",
  "manufacturerId",
]);

export const getReturnCustomsGaps = {
  name: "getReturnCustomsGaps" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    /** Where the parcel is headed; drives which fields customs actually needs. */
    destinationCountry: z.string().nullable(),
    requiredFields: z.array(productCustomsFieldSchema),
    products: z.array(
      z.object({
        /** Raw CockroachDB product.id — what the edit modal writes back with. */
        productId: z.string(),
        title: z.string(),
        sku: z.string().nullable(),
        hsCode: z.string().nullable(),
        originCountry: z.string().nullable(),
        manufacturerId: z.string().nullable(),
        manufacturerName: z.string().nullable(),
        customsDescription: z.string().nullable(),
        materialDescription: z.string().nullable(),
        missingFields: z.array(productCustomsFieldSchema),
        /** Return line variants that resolve to this catalog product. */
        variantIds: z.array(z.string()),
      }),
    ),
    manufacturers: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        mid: z.string().nullable(),
        street1: z.string().nullable(),
        city: z.string().nullable(),
        state: z.string().nullable(),
        postalCode: z.string().nullable(),
        country: z.string().nullable(),
      }),
    ),
    /** Tax IDs this lane's label carries, and whether we hold a number. */
    taxIds: z.array(
      z.object({
        taxIdType: z.enum(["EORI", "VAT", "EIN", "GST", "BN"]),
        issuingAuthority: z.string(),
        satisfied: z.boolean(),
      }),
    ),
  }),
};
